module.exports = __webpack_public_path__ + "static/media/star.769eabd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/star.svg
// module id = 835
// module chunks = 21